// import './styles.css';
import React, { FC } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { formats, modules } from './Textarea.config';

interface TextareaProps {
  content: string;
  setContent: (content: string) => void;
  placeholder?: string;
  readOnly?: boolean;
}

const Textarea: FC<TextareaProps> = ({
  content,
  setContent,
  placeholder = 'Please enter some text...',
  readOnly,
}) => {
  return (
    <ReactQuill
      theme="snow"
      formats={formats}
      modules={modules}
      placeholder={placeholder}
      value={content}
      onChange={setContent}
      readOnly={readOnly}
    />
  );
};

export default Textarea;
